export default __webpack_public_path__ + "static/media/regulatory--no-buses--g1.67236178.png";